import {Epic, ofType} from "redux-observable";
import {AppActions} from "../actions";
import {AppState} from "../AppState";
import {catchError, map, mergeMap, switchMap} from "rxjs/operators";
import {fromFetch} from "rxjs/fetch";
import ApiUrl from "../api/ApiUrl";
import {
    SSO_USER_LOGIN,
    SSOWorkforceOneLoginAction,
    WorkforceOneUserHasLoggedIn,
    WorkforceOneUserLoginFailed
} from "../actions/WorkforceOneLoginActions";

const WorkforceOneSSOUserLoginEpic:  Epic<AppActions, AppActions, AppState> = (action$, state$ ) => {
    return action$.pipe(
        ofType(SSO_USER_LOGIN),
        mergeMap((action:AppActions) => {
                const loginDetailFromAction = action as SSOWorkforceOneLoginAction
                const { ssoToken, ...payload } =  loginDetailFromAction.payload
                const body = JSON.stringify(payload)
                return fromFetch(`${ApiUrl()}FFOrderAccount/SSORequest`,
                    {
                        method: 'POST',
                        credentials: 'omit',
                        body: body,
                        headers: {
                            "IsMarketPlace": "true",
                            'Agent': 'Chrome',
                            "api_version": "1.0",
                            "Accept": "application/json",
                            "Content-Type": "application/json",
                            "Authorization": `Bearer ${ssoToken}`
                        },
                    })
                    .pipe(switchMap(response => response.ok ?
                        response.json():
                        Promise.resolve(null)),
                        catchError(err => {
                            console.error(err);
                            return Promise.resolve(null);
                        })
                        )
                    .pipe(map(json => json != null ?
                        WorkforceOneUserHasLoggedIn(json.data.AuthToken, json.data.UserLoginID, json.data.RequestToken, json.data) :
                        WorkforceOneUserLoginFailed()))
            }
        )
    );
};
export default WorkforceOneSSOUserLoginEpic;
